export enum ClientBookingStatus {
  NoStatus = 'NoStatus',
  Booked = 'Booked',
  Attended = 'Attended',
  NoShow = 'NoShow',
  Cancelled = 'Cancelled',
  Erroneous = 'Erroneous',
  Replaced = 'Replaced',
  GiveUpSlot = 'GiveUpSlot',
  Waitlist = 'Waitlist'
}

export enum ClassStatus {
  Scheduled = 'Scheduled',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Open = 'Open',
}

export enum AppointmentStatus {
  Booked = 'Booked',
  Attended = 'Attended',
  NoShow = 'NoShow',
  Cancelled = 'Cancelled'
}

export enum AppointmentStatusNumeric {
  Booked = 1,
  Attended = 2,
  NoShow = 3,
  Cancelled = 4
}

export enum ClassStatusNumeric {
  Scheduled = 1,
  Cancelled = 2,
  Completed = 3,
  Closed = 4,
}

export enum ClientBookingStatusNumeric {
  Booked = 1,
  Attended = 2,
  NoShow = 3,
  Cancelled = 4,
  Erroneous = 5,
  Replaced = 6,
  GiveUpSlot = 7
}

export enum CalendarView {
  Year = 'year',
  Month = 'month',
  Week = 'week',
  Day = 'day',
  Agenda = 'agenda',
  Trainer = 'trainer',
  Studio = 'studio',
  Schedule = 'schedule'
}

export enum ScheduleType {
  Apppintment = 'appointment',
  Class = 'class'
}

export enum ClassBookingCancellationType {
  None = 1,
  LateCancellation = 2,
  LateCancellationBypass = 3,
}
